export default "__VITE_ASSET__BVp9cogi__"